import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=b813748c&scoped=true&"
import script from "./SignInPage.vue?vue&type=script&lang=js&"
export * from "./SignInPage.vue?vue&type=script&lang=js&"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=b813748c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b813748c",
  null
  
)

export default component.exports